module.exports = __webpack_public_path__ + "img/fotos_4.257d9e05.jpg";